import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../../../../config/config';
import { getEnv } from '../../../../../modules/utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';


@Injectable({
    providedIn: 'root'
 })
export class BatchJobMaintenanceModalService {

   constructor(
      private readonly baseHttpService: BaseHttpService
   ) { }


   public getDailyWarningProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/daily-warning-process`;
      return this.baseHttpService.get(url);
   }

   public getWeeklyWariningProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/weekly-warning-process
    `;
      return this.baseHttpService.get(url);
   }

   public getUserProfileUpdateProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/mesc-user-profile`;
      return this.baseHttpService.get(url);
   }

   public getQuoteAutoDeleteProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/quote-trash-auto-delete`;
      return this.baseHttpService.get(url);
   }

   public getTmacsProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/tmacs`;
      return this.baseHttpService.get(url);
   }

   public getTprMetricProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/tpr-metric`;
      return this.baseHttpService.get(url);
   }

   public getProdFileAutoDeleteProcess(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}job/prod-file-auto-delete`;
      return this.baseHttpService.get(url);
   }

}
